const { useLocation } = require("react-router-dom")
const _ = require("lodash")

const websiteURL = process.env.REACT_APP_BACKEND_URI
const PRODUCTION_STRING = "production"

/**
 * Delay in milliseconds for calling onBlur after onChange
 * @type {number}
 */
export const ON_BLUR_CALL_DELAY = 200

export function resolveBackendURL(endpoint) {
  if (process.env.NODE_ENV === PRODUCTION_STRING) {
    return endpoint
  }

  return `${websiteURL}${endpoint}`
}

export function isProduction() {
  return process.env.NODE_ENV === PRODUCTION_STRING
}

/**
 * Very basic utils to convert any given value into native boolean.
 * - for String, non case sensitive "true" is true, otherwise it's false
 * - for Number, 1 is true, otherwise it's false
 * - for Boolean, then return itself
 * - anything else is false
 *
 * @param value
 * @returns {boolean}
 */
export function asBoolean(value) {
  if (_.isString(value)) {
    const asLowerCase = value.toLowerCase()
    if (asLowerCase === "true") {
      return true
    }
  }

  if (_.isNumber(value) && value === 1) {
    return true
  }

  if (_.isBoolean(value)) {
    return value
  }

  return false
}

/**
 * Determines whether the input is a string or not.
 * @see https://stackoverflow.com/a/7772724/5572258
 * @param {string} s - input to test
 * @returns {boolean} - determines whether the input is a string or not
 */
export function isString(s) {
  return typeof s === "string" || s instanceof String
}

// This small utility function allows a developer to easily manipulate query parameters
export function useQuery() {
  return new URLSearchParams(useLocation().search)
}

// Concats all arguments with slash and tries to remove useless slashes (i.e. "test/", "/a" & "toto/" -> "test/a/toto")
export function buildURLFromRoutes(...routes) {
  const tmp = routes.reduce((acc, route) => {
    if (!route) {
      return acc
    }
    let newRoute = route
    if (newRoute.startsWith("/")) {
      // Remove first character if it's a slash
      newRoute = newRoute.slice(1)
    }
    if (newRoute.endsWith("/")) {
      // Remove last character if it's a slash
      newRoute = newRoute.slice(0, -1)
    }
    acc.push(newRoute)
    return acc
  }, [])
  return tmp.join("/")
}

// Checks if passed URL has the same hostname as current hostname
export function sameHostname(url) {
  const currHostname = window.location.hostname
  try {
    const domain = new URL(url)
    return domain && domain.hostname === currHostname
  } catch {
    // If we arrive here, it means the passed argument is not an URL, so we can assume the same hostname will be used with this (surely "/something" has been passed)
    return true
  }
}
